export type UdaSearchResult = {
  id: string;
  aderente: string;
  usuario_nome: string;
  usuario_email: string;
  usuario_celular: string;
};

export default class Uda {
  id: string;
  usuario: {
    nome: string;
    email: string;
    telefone: string;
  };
  aderente: {
    id: string;
    nome: string;
    slug: string;
  };
  pap: boolean;
  servicesList: Array<any>;
  selectedService: string | null;

  constructor(options: any) {
    this.id = options.id;
    this.aderente = {
      id: options?.aderente?.id,
      nome: options?.aderente?.nome,
      slug: options.aderente?.slug,
    };

    // User
    this.usuario = {
      nome: options?.usuario?.nome,
      email: options?.usuario?.email,
      telefone: options?.usuario?.telefone,
    };

    this.pap = options.pap;

    // Services
    this.servicesList = options.servicesList ? options.servicesList : [];
    this.selectedService = null;
  }
}
